/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Tabs, { Tab } from '@uniiverse/library/components/tabs';
import { connect } from 'react-redux';

import style from './tabs-module.css';

import {
  showUpcomingEvents,
  showPastEvents
} from '../../../../modules/profile/actions';

type Props = {
  data: ProfileQuery,
  showingUpcomingEvents: boolean,
  showingPastEvents: boolean,
  showUpcomingEvents: Function,
  showPastEvents: Function
};

const withStore: Function = connect(
  null,
  {
    showUpcomingEvents,
    showPastEvents
  }
);

const EventTabs = (props: Props): React$Element<*> => {
  const {
    data: { profile },
    showPastEvents,
    showUpcomingEvents,
    showingUpcomingEvents,
    showingPastEvents
  } = props;

  let hostedEventsTab;

  if (profile.hosted && profile.hosted.totalCount > 0) {
    hostedEventsTab = (
      <Tab onClick={showPastEvents} active={showingPastEvents}>
        <FormattedMessage id="profile.past-events" defaultMessage="Past events" />
      </Tab>
    );
  }

  let eventsMessage;

  if (profile.host) {
    eventsMessage = <FormattedMessage
      id="profile.events-by"
      defaultMessage="Events by {name}"
      values={{ name: profile.firstName }}
    />;
  }
  else {
    eventsMessage = <FormattedMessage
      id="profile.events"
      defaultMessage="Events"
    />;
  }

  return (
    <div>
      <div className={style.title} data-cs-mask={true}>
        {eventsMessage}
      </div>
      <Tabs>
        <Tab onClick={showUpcomingEvents} active={showingUpcomingEvents}>
          <FormattedMessage id="profile.upcoming-events" defaultMessage="Upcoming events" />
        </Tab>
        {hostedEventsTab}
      </Tabs>
    </div>
  );
};

export default withStore(EventTabs);



// WEBPACK FOOTER //
// ./src/components/profile/events/layouts/tabs.js